import { render } from "./CampaignsManagementDetailsCampaigns.vue?vue&type=template&id=e829acba&scoped=true"
import script from "./CampaignsManagementDetailsCampaigns.vue?vue&type=script&lang=js"
export * from "./CampaignsManagementDetailsCampaigns.vue?vue&type=script&lang=js"

import "./CampaignsManagementDetailsCampaigns.vue?vue&type=style&index=0&id=e829acba&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e829acba"]])

export default __exports__